import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { VerifyAction } from '@/common/stores/system.store';
import { AuthService } from '../services/auth.service';

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const store = inject(Store);
  const router = inject(Router);
  const authService = inject(AuthService);

  return store.dispatch(new VerifyAction()).pipe(
    map(response => {
      let user = null;
      if (response.system.user) {
        user = response.system.user;
      }

      const isAuthorized = authService.isAuthorizedForUser(response.system.user, route.data['roles'] || []);

      // If this is the login page do nothing
      if (state.url.startsWith("/member/login")) {
        return true;
      }

      if (!isAuthorized) {
        router.navigate(["/member/login"]);
        return false;
      }

      return true;
    })
  );
};
